export default class InvalidRequestDataException extends Error {
  constructor(message: string) {
    super(message);
  }
}